import { Tab } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import React, { memo } from "react";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";

interface EnforcementNoticeTabsProps {
    cardName: ENoticeTabs;
    handleChangeTab: (newTab: ENoticeTabs) => void;
}

export const PublicEnforcementNoticeTabs: ENoticeTabs[] = [RecordDetailsTabNames.Summary, RecordDetailsTabNames.Documents, RecordDetailsTabNames.Map];

const EnforcementNoticeTabs: React.FC<EnforcementNoticeTabsProps> = memo((props) => {
    const { cardName, handleChangeTab } = props;

    return (
        <Tabs aria-label="Notice Navigation Tabs" sx={{ margin: "2rem 0 3rem 0" }} value={cardName} onChange={(event, newTab: ENoticeTabs) => handleChangeTab(newTab)}>
            {PublicEnforcementNoticeTabs.map((tabName) => {
                return <Tab key={tabName} disableRipple label={tabName} value={tabName}></Tab>;
            })}
        </Tabs>
    );
});

type ENoticeTabs = RecordDetailsTabNames.Summary | RecordDetailsTabNames.Documents | RecordDetailsTabNames.Map;

export default EnforcementNoticeTabs;
export type { ENoticeTabs };
